__turbopack_context__.v({
  "article": "style-module-scss-module__mdg9_q__article",
  "bottomInfo": "style-module-scss-module__mdg9_q__bottomInfo",
  "hideDefaultCursor": "style-module-scss-module__mdg9_q__hideDefaultCursor",
  "infoWrapper": "style-module-scss-module__mdg9_q__infoWrapper",
  "media": "style-module-scss-module__mdg9_q__media",
  "mediaWrapper": "style-module-scss-module__mdg9_q__mediaWrapper",
  "newLabel": "style-module-scss-module__mdg9_q__newLabel",
  "tagsWrapper": "style-module-scss-module__mdg9_q__tagsWrapper",
  "timeToRead": "style-module-scss-module__mdg9_q__timeToRead",
  "title": "style-module-scss-module__mdg9_q__title",
  "wrapper": "style-module-scss-module__mdg9_q__wrapper",
});
